import Enums from "../enums/enums";
import { GetIsDevelop } from "../helper/shareHelper";
import * as AllFunction from "./allFunction";

export default {
  computed: {
    Emi() {
      return this.$route.query.emi ? this.$route.query.emi : "";
    },
    Eui() {
      return btoa(parseInt(this.$store.getters.getUserModel ? this.$store.getters.getUserModel.userId : 0));
    },
    isDevelop() {
      return GetIsDevelop();
    },
  },
  data() {
    return {
      Enums: Enums,
    };
  },
  methods: {
    setNumberDecimals(value, decimal) {
      return AllFunction.setNumberDecimals(value, decimal);
    },
    setNumber(value) {
      return AllFunction.setNumber(value);
    },
    setDateFormat(date) {
      return AllFunction.setDateFormat(date);
    },
    bankTypeName(bankType) {
      switch (bankType) {
        case Enums.BankType.None:
          return "";
          break;
        case Enums.BankType.CurrentAccount:
          return "บัญชีกระแสรายวัน";
          break;
        case Enums.BankType.SavingAccount:
          return "บัญชีออมทรัพย์";
          break;
        case Enums.BankType.FixedDeposit:
          return "เงินฝากประจำ";
          break;
      }
    },
    checkStatusClass(transactionTableStatus) {
      switch (transactionTableStatus) {
        case Enums.TransactionTableViewStatusType.Draft:
          return "statusColorBorderGrey";
          break;
        case Enums.TransactionTableViewStatusType.AwaitApproval:
          return "statusColorBorderOrange";
          break;
        case Enums.TransactionTableViewStatusType.WaitingPayment:
          return "statusColorBlue";
          break;
        case Enums.TransactionTableViewStatusType.OverDue:
          return "statusColorRed";
          break;
        case Enums.TransactionTableViewStatusType.Paid:
          return "statusColorGreen";
          break;
        case Enums.ImportTableViewStatusType.All:
        case Enums.TransactionTableViewStatusType.All:
          return "statusColorBlack";
          break;
        case Enums.TransactionTableViewStatusType.AwaitReceipt:
          return "statusColorOrange";
          break;
        case Enums.TransactionTableViewStatusType.GotReceipt:
          return "statusColorGreen";
          break;
        case Enums.TransactionTableViewStatusType.Voided:
          return "statusColorGrey";
          break;
      }
    },
    GetQuotationStatusClass(tableStatus, status) {
      if (tableStatus == Enums.QuotationTableViewStatusType.Voided) {
        return "statusColorGrey";
      } else {
        switch (status) {
          case Enums.QuotationStatus.Draft:
            return "statusColorBorderGrey";
          case Enums.QuotationStatus.AwaitApproval:
            return "statusColorBorderOrange";
          case Enums.QuotationStatus.AwaitResponse:
            return "statusColorBorderBlue";
          case Enums.QuotationStatus.Expired:
            return "statusColorRed";
          case Enums.QuotationStatus.ApprovedOrAccepted:
            return "statusColorBlue";
          case Enums.QuotationStatus.Partial:
            return "statusColorBorderGreen";
          case Enums.QuotationStatus.Voided:
          case Enums.QuotationStatus.Rejected:
            return "statusColorGrey";
          case Enums.QuotationStatus.Completely:
            return "statusColorGreen";
        }
      }
    },
    GetEtaxInvoiceStatusClass(eTaxInvoiceId) {
      if (eTaxInvoiceId > 0) {
        return "statusColorGreen";
      } else {
        return "statusColorBorderOrange";
      }
    },
    GetInvoiceStatusClass(tableStatus, status, financeType) {
      if (tableStatus == Enums.InvoiceTableViewStatusType.Voided) {
        return "statusColorGrey";
      } else {
        switch (status) {
          case Enums.InvoiceStatus.Draft:
            return "statusColorBorderGrey";
          case Enums.InvoiceStatus.AwaitApproval:
            return "statusColorBorderOrange";
          case Enums.InvoiceStatus.Outstanding:
            return "statusColorBlue";
          case Enums.InvoiceStatus.Overdue:
            return "statusColorRed";
          case Enums.InvoiceStatus.PaidOrAwaitReceipt:
            if (financeType == Enums.FinanceType.InFlow) {
              return "statusColorGreen";
            } else {
              return "statusColorOrange";
            }
          case Enums.InvoiceStatus.GotReceipt:
            return "statusColorGreen";
          case Enums.InvoiceStatus.Voided:
            return "statusColorGrey";
        }
      }
    },
    GetReceiptStatusClass(tableStatus, status) {
      if (tableStatus == Enums.ReceiptTableViewStatusType.Voided) {
        return "statusColorGrey";
      } else {
        switch (status) {
          case Enums.ReceiptStatus.Draft:
            return "statusColorBorderGrey";
          case Enums.ReceiptStatus.AwaitApproval:
            return "statusColorBorderOrange";
          case Enums.ReceiptStatus.Approved:
            return "statusColorGreen";
          case Enums.ReceiptStatus.Voided:
            return "statusColorGrey";
        }
      }
    },

    GetTaxInvoiceStatusClass(tableStatus, status) {
      if (tableStatus == Enums.TaxInvoiceTableViewStatusType.Voided) {
        return "statusColorGrey";
      } else {
        switch (status) {
          case Enums.TaxInvoiceStatus.Draft:
            return "statusColorBorderGrey";
          case Enums.TaxInvoiceStatus.AwaitApproval:
            return "statusColorBorderOrange";
          case Enums.TaxInvoiceStatus.Approved:
            return "statusColorGreen";
          case Enums.TaxInvoiceStatus.Voided:
            return "statusColorGrey";
        }
      }
    },
    GetCreditNoteStatusClass(tableStatus, status) {
      if (tableStatus == Enums.CreditNoteTableViewStatusType.Voided) {
        return "statusColorGrey";
      } else {
        switch (status) {
          case Enums.CreditNoteStatus.Draft:
            return "statusColorBorderGrey";
          case Enums.CreditNoteStatus.AwaitApproval:
            return "statusColorBorderOrange";
          case Enums.CreditNoteStatus.Approved:
            return "statusColorBlue";
          case Enums.CreditNoteStatus.Paid:
            return "statusColorGreen";
          case Enums.CreditNoteStatus.Voided:
            return "statusColorGrey";
        }
      }
    },
    GetDebitNoteStatusClass(tableStatus, status) {
      if (tableStatus == Enums.DebitNoteTableViewStatusType.Voided) {
        return "statusColorGrey";
      } else {
        switch (status) {
          case Enums.DebitNoteStatus.Draft:
            return "statusColorBorderGrey";
          case Enums.DebitNoteStatus.AwaitApproval:
            return "statusColorBorderOrange";
          case Enums.DebitNoteStatus.Approved:
            return "statusColorBlue";
          case Enums.DebitNoteStatus.Paid:
            return "statusColorGreen";
          case Enums.DebitNoteStatus.Voided:
            return "statusColorGrey";
        }
      }
    },
    ChangeFormType(formType) {
      return AllFunction.ChangeFormType(formType);
    },
    GetPercentChangeValue(value, formType) {
      return AllFunction.GetPercentChangeValue(value, formType);
    },
    GetMonthName(index, language = "th") {
      return AllFunction.GetMonthName(index, language);
    },
    CheckTextLabel(textInput) {
      if (textInput) {
        return textInput;
      } else {
        return "-";
      }
    },
  },
};
